export const topicsOfCovers = [
  { title: "기념일 축하" },
  { title: "팀 소개" },
  { title: "동기부여 명언" },
  { title: "비하인드 씬" },
  { title: "고객 후기" },
  { title: "제품 팁 & 트릭" },
  { title: "설문 조사" },
  { title: "시즌 인사" },
  { title: "신제품 출시" },
  { title: "특별 할인" },
  { title: "커뮤니티 행사" },
  { title: "자선 지원" },
  { title: "재미있는 사실" },
  { title: "퀴즈 질문" },
  { title: "DIY 튜토리얼" },
  { title: "산업 뉴스" },
  { title: "다가오는 행사" },
  { title: "성공 사례" },
  { title: "직원 스포트라이트" },
  { title: "사용자 생성 콘텐츠" },
];

// 신고 사유. 예전엔 14개였고 다른 앱(중국 숏폼)에서 그대로 옮겨온 것이었다 —
// "허위 정치 정보"("국가 안보에 해를 끼치는 발언"), "콘텐츠 이용 불가" 같은 항목과,
// 다음 단계의 "정치적/경제적/문화적/사회적 안전 위협 · 국가 안보 위협" 5개가 그렇다.
// 우리 서비스에 맞는 9개로 다시 썼다(2026-08-02, founder 승인).
//
// 하나만 고른다 — 화면에서도 동그라미로 보여준다.
export const reportCommentOptions = [
  { option: "pornographic_and_vulgar", subtext: "pornographic_and_vulgar_subtext", isSelected: false },
  { option: "involving_minors", subtext: "involving_minors_subtext", isSelected: false },
  { option: "illegal_and_irregular", subtext: "illegal_and_irregular_subtext", isSelected: false },
  { option: "false", subtext: "false_subtext", isSelected: false },
  { option: "insult_and_provocations", subtext: "insult_and_provocations_subtext", isSelected: false },
  { option: "suspected_fraud", subtext: "suspected_fraud_subtext", isSelected: false },
  { option: "copyright_infringement", subtext: "copyright_infringement_subtext", isSelected: false },
  { option: "suspected_suicide", subtext: "suspected_suicide_subtext", isSelected: false },
  { option: "other", subtext: "other_subtext", isSelected: false },
];

export const creatorNavLinks = [
  {
    title: "Home",
    icon: "mdi-light:home",
    link: "/creator",
  },
  {
    title: "Content Manager",
    icon: "mdi-light:book-plus",
    link: "/creator/note-manager",
  },
  {
    title: "Account Overview",
    icon: "material-symbols-light:deployed-code-account-outline-rounded",
    link: "/creator/account-overview",
  },
  {
    title: "Profile",
    icon: "guidance:user-1",
    link: "/creator/profile-settings",
  },
];

export const placeFilters = [
  {
    id: 1,
    filter_name: "demographic",
    filter_color: "#fe7d3c",
    can_choose_multiple: true,
    filter_options: [
      {
        filter_value: 20,
        filter_label: "twenties",
        is_selected: false,
      },
      {
        filter_value: 30,
        filter_label: "thirties",
        is_selected: false,
      },
      {
        filter_value: 40,
        filter_label: "forties",
        is_selected: false,
      },
      {
        filter_value: 50,
        filter_label: "fifties",
        is_selected: false,
      },
      {
        filter_value: 60,
        filter_label: "60_and_above",
        is_selected: false,
      },
    ],
  },
  {
    id: 2,
    filter_name: "category",
    filter_color: "#fbc944",
    show: true,
    can_choose_multiple: false,
    filter_options: [
      {
        filter_value: "korean food",
        filter_label: "korean_cuisine",
        is_selected: false,
      },
      {
        filter_value: "italian food",
        filter_label: "italian_cuisine",
        is_selected: false,
      },
      {
        filter_value: "thai food",
        filter_label: "thai_cuisine",
        is_selected: false,
      },
      {
        filter_value: "japanese food",
        filter_label: "japanese_cuisine",
        is_selected: false,
      },
      {
        filter_value: "chinese food",
        filter_label: "chinese_cuisine",
        is_selected: false,
      },
      {
        filter_value: "vietnamese food",
        filter_label: "vietnamese_cuisine",
        is_selected: false,
      },
      {
        filter_value: "cafe_desert",
        filter_label: "cafe_desert",
        is_selected: false,
      },
    ],
  },
  {
    id: 3,
    filter_name: "purpose_of_visit",
    filter_color: "#005274",
    show: true,
    can_choose_multiple: true,
    filter_options: [
      {
        filter_value: "lunch",
        filter_label: "lunch",
        is_selected: false,
      },
      {
        filter_value: "breakfast",
        filter_label: "breakfast",
        is_selected: false,
      },
      {
        filter_value: "dinner",
        filter_label: "dinner",
        is_selected: false,
      },
      {
        filter_value: "date",
        filter_label: "date",
        is_selected: false,
      },
      {
        filter_value: "diet",
        filter_label: "diet",
        is_selected: false,
      },
      {
        filter_value: "dinner party",
        filter_label: "dinner_party",
        is_selected: false,
      },
    ],
  },
  {
    id: 4,
    filter_name: "facilities",
    filter_color: "#3180a1",
    show: true,
    can_choose_multiple: true,
    filter_options: [
      {
        filter_value: "parking",
        filter_label: "parking",
        is_selected: false,
      },
      {
        filter_value: "private room",
        filter_label: "private_room",
        is_selected: false,
      },
      {
        filter_value: "pets allowed",
        filter_label: "pets_allowed",
        is_selected: false,
      },
      {
        filter_value: "valet available",
        filter_label: "valet_available",
        is_selected: false,
      },
      {
        filter_value: "colquy free",
        filter_label: "colquy_free",
        is_selected: false,
      },
      {
        filter_value: "outdoor seating",
        filter_label: "outdoor_seating",
        is_selected: false,
      },
    ],
  },
  {
    id: 5,
    filter_name: "amenities",
    filter_color: "#5e4c8a",
    show: true,
    can_choose_multiple: true,
    filter_options: [
      {
        filter_value: "luxurious",
        filter_label: "luxurious",
        is_selected: false,
      },
      {
        filter_value: "quiet",
        filter_label: "quiet",
        is_selected: false,
      },
      {
        filter_value: "pretty",
        filter_label: "pretty",
        is_selected: false,
      },
      {
        filter_value: "neat",
        filter_label: "neat",
        is_selected: false,
      },
      {
        filter_value: "formal",
        filter_label: "formal",
        is_selected: false,
      },
      {
        filter_value: "generous",
        filter_label: "generous",
        is_selected: false,
      },
      {
        filter_value: "value for money",
        filter_label: "value_for_money",
        is_selected: false,
      },
    ],
  },
  {
    id: 6,
    filter_name: "certified_restaurants",
    filter_color: "#0ac7cd",
    can_choose_multiple: true,
    filter_options: [
      {
        filter_value: "michelin",
        filter_label: "michelin",
        is_selected: false,
      },
      {
        filter_value: "the best road",
        filter_label: "the_best_road",
        is_selected: false,
      },
      {
        filter_value: "centinnial store",
        filter_label: "centinnial_store",
        is_selected: false,
      },
    ],
  },
  {
    id: 7,
    filter_name: "region",
    filter_color: "#42a392",
    can_choose_multiple: true,
    filter_options: [],
  },
];
